import React, { useState } from 'react';
import { Button, Modal } from '@material-ui/core';
import Map from '@components/Map';

export default props => {
  const [is_show_edit_map, set_is_show_edit_map] = useState(false);

  const is_select_coordinate = props.mode === 'select_coordinate';
  const is_draw = props.mode === 'draw';

  const onConfirm = data => {
    if (!!props.onConfirmDraw) {
      props.onConfirmDraw(data);
    }
    set_is_show_edit_map(false);
  };
  return (
    <>
      <Button className="bg-primary text-white w-100" onClick={() => set_is_show_edit_map(true)}>
        {is_select_coordinate && 'Pick Coordinate'}
        {is_draw && 'Lukis'}
      </Button>
      <Modal
        className="m-5"
        open={is_show_edit_map}
        onClose={() => set_is_show_edit_map(false)}
      >
        <Map
          onConfirmDraw={onConfirm}
          draw_data={props.draw_data}
          is_draw={is_draw}
          is_select_coordinate={is_select_coordinate}
        />
      </Modal>
      {props.draw_data?.features.length > 0 && (
        <div className="w-100 mt-1" style={{ height: 150 }}>
          <Map draw_data={props.draw_data} onClick={() => set_is_show_edit_map(true)} />
        </div>
      )}
    </>
  );
};
